import { render, staticRenderFns } from "./DecidedMasterProposals.vue?vue&type=template&id=633829be&scoped=true&"
import script from "./DecidedMasterProposals.vue?vue&type=script&lang=js&"
export * from "./DecidedMasterProposals.vue?vue&type=script&lang=js&"
import style0 from "./DecidedMasterProposals.vue?vue&type=style&index=0&id=633829be&prod&lang=css&"
import style1 from "./DecidedMasterProposals.vue?vue&type=style&index=1&id=633829be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633829be",
  null
  
)

export default component.exports